// src/components/Footer.jsx — v7
// CHANGED FROM v6 (19 Jul 2026) — two fixes:
// 1. REAL BUG: Quick Links' "Cashback Program" still pointed to the
//    old /loyalty path — that route no longer exists (renamed to
//    /cashback-program in App.jsx), so this link was silently dead-
//    ending. Fixed.
// 2. Removed the "operated by Amit Sahgal" line entirely, per Amit's
//    explicit call — doesn't want his personal name on public display
//    either, not just InsideOUT. Footer now has no legal-entity
//    disclosure line at all, just the copyright line. FLAGGED AGAIN:
//    this may have a separate GST/e-commerce disclosure angle
//    independent of brand-safety — worth a CA check when convenient,
//    not blocking.
// CHANGED FROM v5 (19 Jul 2026): removed the "trading name of
// InsideOUT, GSTIN ..." line entirely, per Amit's explicit "no chances
// at all" call on InsideOUT separation — this was live, customer-
// facing text on every single page (Footer renders sitewide), the
// highest-risk reference found in the whole codebase. Replaced with a
// plain legal-entity line naming Amit Sahgal directly instead of the
// InsideOUT trade name — no GSTIN, no searchable trace back to the
// other business. NOTE (flagged, not resolved): GST/tax disclosure
// requirements for Indian e-commerce are a separate legal question
// from Meta ad safety — worth a CA check at some point, not blocking.
// CHANGED FROM v4: "Loyalty Programme" link text renamed to "Cashback
// Program" — matches the site-wide rename applied elsewhere (Checkout,
// WhatsApp FAQ). Route path (/loyalty) unchanged, only the visible label.
import React from 'react';
import { useNavigate } from 'react-router-dom';
export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer style={{
      background: '#0D1117',
      padding: '32px 20px 100px',
      marginTop: 20,
    }}>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--off-white)', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: 6 }}>
          NOBRANDSTORE
        </div>
        <div style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6 }}>
          Real clothes. Real prices. No name tax.
        </div>
      </div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontSize: 10, letterSpacing: '0.12em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 12 }}>Quick Links</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[
            { label: 'About Us', path: '/about' },
            { label: 'Contact Us', path: '/contact' },
            { label: 'Cashback Program', path: '/cashback-program' },
            { label: 'Reseller Pricing', path: '/reseller-info' },
            { label: 'Shipping Policy', path: '/shipping' },
            { label: 'Return Policy', path: '/returns' },
            { label: 'Privacy Policy', path: '/privacy' },
            { label: 'Terms of Service', path: '/terms' },
          ].map(link => (
            <button
              key={link.path}
              onClick={() => navigate(link.path)}
              style={{ background: 'none', border: 'none', color: 'rgba(244,242,238,0.6)', fontSize: 13, textAlign: 'left', cursor: 'pointer', padding: 0, fontFamily: 'var(--font)' }}
            >
              {link.label}
            </button>
          ))}
        </div>
      </div>
      <div style={{ borderTop: '0.5px solid rgba(244,242,238,0.08)', paddingTop: 20 }}>
        <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 4 }}>📧 nobrandstore3@gmail.com</div>
        <div style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 16 }}>📍 Chennai, Tamil Nadu, India</div>
        <div style={{ fontSize: 11, color: 'rgba(244,242,238,0.3)' }}>© 2026 NoBrand Store. All rights reserved.</div>
      </div>
    </footer>
  );
}